import React from 'react';
import { View } from 'react-native';
import { formatParlevelAndQuantity } from '../../../common/utils/utils';
import { useConfirmStockLevelsContext } from '../../utils/context';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import { Counter, SecondaryButton } from '../../design/components';

const ConfirmValuesButtons = ({ planogramItem }) => {
	const styles = useThemedStyles(createStyles);
	const {
		changeStockItem,
		onReportIncorrectStockSetting,
		hasReportedStockSetting,
	} = useConfirmStockLevelsContext();
	const showReportAction = Boolean(planogramItem?.product && onReportIncorrectStockSetting);
	const formatValue = value => formatParlevelAndQuantity(value, planogramItem.product);

	return (
		<View style={styles.column}>
			<View style={styles.counters}>
				<Counter
					label="Before"
					value={planogramItem.productQuantityPreService || 0}
					formatValue={formatValue}
					onChange={changeStockItem(planogramItem.id, 'productQuantityPreService')}
				/>
				<Counter
					label="After"
					value={planogramItem.presentProductQuantity || 0}
					formatValue={formatValue}
					onChange={changeStockItem(planogramItem.id, 'presentProductQuantity')}
				/>
			</View>
			{
				showReportAction && (
					<SecondaryButton
						variant="tonal"
						label={hasReportedStockSetting?.(planogramItem.id) ? 'Reported' : 'Report a wrong value'}
						onPress={() => onReportIncorrectStockSetting(planogramItem.id)}
					/>
				)
			}
		</View>
	);
};

const createStyles = ({ ui: { space } }) => ({
	column: {
		gap: space.md,
	},
	counters: {
		flexDirection: 'row',
		justifyContent: 'space-around',
	},
});

export default ConfirmValuesButtons;
